type StatusType = 'loading' | 'deleting' | true | false | null

export class UploadableFile {
  private _file: File
  private _id: string
  private _url: string
  private _status: StatusType
  private _isUploaded: boolean
  private _base64: string | undefined

  get file(): File {
    return this._file
  }

  set file(value: File) {
    this._file = value
  }

  get id(): string {
    return this._id
  }

  set id(value: string) {
    this._id = value
  }

  get url(): string {
    return this._url
  }

  set url(value: string) {
    this._url = value
  }

  get status(): StatusType {
    return this._status
  }

  set status(value: StatusType) {
    this._status = value
  }

  get isUploaded(): boolean {
    return this._isUploaded
  }

  set isUploaded(value: boolean) {
    this._isUploaded = value
  }

  get base64(): string | undefined {
    return this._base64
  }

  set base64(value: string | undefined) {
    this._base64 = value
  }

  public getExtension() {
    return this.file.type.split('/').pop()
  }

  constructor(file: File, isUploaded: boolean, base64String?: string) {
    this._file = file
    this._id = `${file.name}-${file.size}-${file.lastModified}-${file.type}`
    this._url = URL.createObjectURL(file)
    this._status = null
    this._isUploaded = isUploaded
    this._base64 = base64String
  }
}
